
// https://immerjs.github.io/immer/installation/
import {enableMapSet} from "immer";
enableMapSet();


import {WebcastAuctionConnectData_TypeDef} from "@nextlot/core/webcast";
import NextLotJSDATA, {NextLotJSDATA_TypeDef} from "@nextlot/core/NextLotJSDATA";
import {WebcastScreenTypeCodesEnum} from "@nextlot/core/StaticModelsAndConstants";


declare global {
    interface Window {
        gon_NextLotJSDATA: any,
        NextLotWebcastAuctionConnectData: WebcastAuctionConnectData_TypeDef,
    }
}




function _loadClerkScreen(appConfigData, webcastConnectData) {
    import('./screen_clerk').then((screen) => {
        screen.load(appConfigData, webcastConnectData);
    });
}

function _loadBidderScreen(appConfigData, webcastConnectData) {
    import('./screen_bidder').then((screen) => {
        screen.load(appConfigData, webcastConnectData);
    });
}

function _loadOnsiteScreen(appConfigData, webcastSaleConnectData) {
    import('./screen_onsite').then((screen) => {
        screen.load(appConfigData, webcastSaleConnectData);
    });
}

function _loadAuctioneerScreen(appConfigData, webcastSaleConnectData) {
    import('./screen_auctioneer').then((screen) => {
        screen.load(appConfigData, webcastSaleConnectData);
    });
}

function _loadViewerEmbeddedScreen(appConfigData, webcastSaleConnectData) {
    import('./screen_viewer_embedded').then((screen) => {
        screen.load(appConfigData, webcastSaleConnectData);
    });
}





document.addEventListener('DOMContentLoaded', function() {

    // we are expecting `window.NextLotWebcastAuctionConnectData` to be set in the html page view that contains this script

    const appConfigData:NextLotJSDATA_TypeDef = NextLotJSDATA;
    const webcastConnectData:WebcastAuctionConnectData_TypeDef = window.NextLotWebcastAuctionConnectData;

    if (webcastConnectData && appConfigData) {
        console.info('FOUND window.NextLotJSDATA:', appConfigData);
        console.info('FOUND window.NextLotWebcastAuctionConnectData:', webcastConnectData);

        const screenType = webcastConnectData.screenType;


        if (WebcastScreenTypeCodesEnum.clerk == screenType) {
            _loadClerkScreen(appConfigData, webcastConnectData);
        }
        else if (WebcastScreenTypeCodesEnum.bidder === screenType || WebcastScreenTypeCodesEnum.viewer === screenType) {
            _loadBidderScreen(appConfigData, webcastConnectData);
        }
        else if (WebcastScreenTypeCodesEnum.viewer_embedded === screenType) {
            _loadViewerEmbeddedScreen(appConfigData, webcastConnectData);
        }
        else if (WebcastScreenTypeCodesEnum.onsite === screenType) {
            _loadOnsiteScreen(appConfigData, webcastConnectData);
        }
        else if (WebcastScreenTypeCodesEnum.auctioneer === screenType) {
            _loadAuctioneerScreen(appConfigData, webcastConnectData);
        }

        else {
            alert('screenType `'+ screenType +'` invalid or not implemented');
        }
    }
    else {
        alert('window.NextLotWebcast***Data not found!');
        throw new Error('need to set window.NextLotWebcast***Data');
    }
});

